import React from "react";
import { Contract } from "@/types";
import CTA from "@/components/atoms/CTA";
import { useTranslation } from "react-i18next";
import { useModal } from "@/contexts/ModalContext";
import { useCreateContractWizardStore } from "@/stores/createContractWizardStore";

const RenewContractButton = ({ contract }: { contract: Contract }) => {
  const { t } = useTranslation();
  const { openModal } = useModal();
  const open = useCreateContractWizardStore((state) => state.open);

  const handleToggleOfArchive = () => {
    openModal({
      title: t("notifications:contracts.confirmContractRenewalTitle"),
      content: "", //t("notifications:contracts.confirmContractRenewalContent"),
      type: "confirmation",
      primaryAction: {
        onClick: async () => {
          open(contract.id);
        },
        text: t("actions:renewContract"),
        intent: "affirm",
      },
      secondaryAction: {
        onClick: () => {
          // just close it
        },
        text: t("actions:cancel"),
        intent: "negate",
      },
    });
  };

  return (
    <CTA
      size="sm"
      onClick={() => handleToggleOfArchive()}
      data-testid={"renew-contract-btn"}
      intent="secondary"
      tt="uppercase"
    >
      {t("actions:renewContract")}
    </CTA>
  );
};

export default RenewContractButton;
